import {
  Lead,
  LeadAvailablePipelineAction,
  LeadSource,
  LeadStatus,
} from 'models/Leads';
import useLeadPipelineAction from './useLeadPipelineAction';

const airbnbActionsWithButtons = [
  LeadAvailablePipelineAction.AIRBNB_PRE_APPROVE,
  LeadAvailablePipelineAction.AIRBNB_REVIEW_ALTERATION,
];

const standardActionsWithButtons = [
  LeadAvailablePipelineAction.DECLINE_PENDING,
  LeadAvailablePipelineAction.ACCEPT_PENDING,
  LeadAvailablePipelineAction.CANCEL_BOOKING,
];

export const buttonStyles = {
  [LeadAvailablePipelineAction.CANCEL_BOOKING]: 'danger',
  [LeadAvailablePipelineAction.DECLINE_PENDING]: 'danger',
  [LeadAvailablePipelineAction.AIRBNB_REVIEW_ALTERATION]: 'primary',
};

// @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
function isActionAvailable({ action, lead }) {
  if (action === LeadAvailablePipelineAction.CANCEL_BOOKING) {
    return lead?.source === LeadSource.DIRECT_AIRBNB;
  }

  return true;
}

function getAvailablePipelineActions(lead: Lead) {
  // Airbnb alteration review is not returned as part of the available pipeline actions payload
  if (lead?.airbnbAlteration && lead?.status !== LeadStatus.ARCHIVED) {
    return [
      LeadAvailablePipelineAction.AIRBNB_REVIEW_ALTERATION,
      ...(lead.availablePipelineActions ?? []),
    ];
  }

  return lead?.availablePipelineActions;
}

const useLeadActions = ({ lead }: { lead: Lead }) => {
  const { takeAction, isExecutingAction } = useLeadPipelineAction();
  const availablePipelineActions = getAvailablePipelineActions(lead);

  const airbnbActions =
    availablePipelineActions
      ?.filter((action) => airbnbActionsWithButtons.includes(action))
      .sort(
        (action1, action2) =>
          airbnbActionsWithButtons.indexOf(action1) -
          airbnbActionsWithButtons.indexOf(action2),
      ) || [];

  const standardActions =
    availablePipelineActions
      ?.filter(
        (action) =>
          standardActionsWithButtons.includes(action) &&
          isActionAvailable({ action, lead }),
      )
      .sort(
        (action1, action2) =>
          standardActionsWithButtons.indexOf(action1) -
          standardActionsWithButtons.indexOf(action2),
      ) || [];

  return {
    airbnbActions,
    standardActions,
    takeAction,
    isExecutingAction,
  };
};

export default useLeadActions;
